'use strict';

function service($q, Global, $state, $http) {
    let _this = this;
    // get settings for specific key
    // USAGE: VARIABLE = settings.get(KEY);
    _this.get = function (key) {
        let controller = $state.current.controller;
        // if controller exists in the settings
        if (Global.user.settings_local.hasOwnProperty(controller)) {
            // if the settings key exists in the controller
            if (Global.user.settings_local[controller].hasOwnProperty(key)) {
                // send back the value of the key
                return Global.user.settings_local[controller][key];
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    // set settings for specific key
    // USAGE: settings.set(KEY, VALUE).then(function () { DO SOMETHING });
    // NOTE: set VALUE to false (boolean) if removing a value - the server will take care of removing the setting obj's values
    _this.set = function (key, value) {
        let deferred = $q.defer();
        function run(k, v, callback) {
            // grab the controller name from the state object
            let controller = $state.current.controller;
            // make post to server side to do the work
            $http({
                method: 'POST',
                url: api+'/api/users/settingslocal',
                data: {
                    key: key,
                    value: value,
                    controller: controller
                }
            })
            .success(function (settings) {
                Global.user.settings_local = settings;
                return callback(true);
            });
        }
        run(key, value, function () {
            deferred.resolve();
        })
        return deferred.promise;
    }
    return _this;
}

service.$inject = ['$q', 'Global', '$state', '$http'];
module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/pages/services/settings.js
 **/